import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/zachary/chezmoi/node_modules/.pnpm/next@15.2.0-canary.33_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
